/**
 * 房源管理路由
 */
export default {
  path: '/channel',
  name: 'channel',
  redirect: '/channel/channelManage',
  component: () => import('../views/channel/index.vue'),
  meta: {
    headerTitle: '渠道',
    icon: 'ab-iconfont ab-icon-loop',
    auth: 1010
  },
  children: [
    {
      path: 'channelManage',
      name: 'channelManage',
      redirect: '/channel/channelManage/channelAccount',
      component: () => import('../views/channel/channelManage/index.vue'),
      meta: {
        headerTitle: '直连渠道',
        icon: 'channel'
      },
      children: [
        {
          path: 'channelAccount',
          name: 'channelAccount',
          redirect: '/channel/channelManage/channelAccount/channelAccountList',
          component: () => import('../views/channel/channelManage/account/index.vue'),
          meta: {
            headerTitle: '渠道账号'
          },
          children: [
            {
              path: 'channelAccountList',
              name: 'channelAccountList',
              component: () => import('../views/channel/channelManage/account/list.tsx'),
              meta: {
                headerTitle: '渠道账号列表'
              }
            }
          ]
        },
        {
          path: 'channelHouseType',
          name: 'channelHouseType',
          redirect: '/channel/channelManage/channelHouseType/houseList',
          component: () => import('../views/channel/channelManage/houseType/index.vue'),
          meta: {
            headerTitle: '渠道房型'
          },
          children: [
            {
              path: 'houseList',
              name: 'houseList',
              component: () => import('../views/channel/channelManage/houseType/houseList.vue'),
              meta: {
                headerTitle: '渠道房型'
              }
            },
            {
              path: 'bindHouse',
              name: 'bindHouse',
              component: () => import('../views/channel/channelManage/houseType/bindHouse.vue'),
              meta: {
                headerTitle: '关联房号'
              }
            }
          ]
        },
        {
          path: 'channelRoomCalendar',
          name: 'channelRoomCalendar',
          component: () => import('../views/channel/channelManage/roomStateCalendar/index.vue'),
          meta: {
            headerTitle: '房源房态日历'
          }
        }
      ]
    },
    {
      path: 'channelSetting',
      name: 'channelSetting',
      component: () => import('../views/channel/setting/index.vue'),
      meta: {
        headerTitle: '直连设置',
        icon: 'channelSetting'
      }
    }
  ]
}
